import { componentsConfig as defaultConfig } from "srs.sharedcomponents/lib/esm/components/config";
import WelcomeBuilder from "srs.sharedcomponents/lib/esm/components/organisms/Welcome/BuilderContent/WelcomeBuilder"
import NotFoundPageComponent from "srs.sharedcomponents/lib/esm/shared-components/srs.notFoundPage.component";
import RegistrationComponent from "../../srs.registration.component";

const componentsConfig = { ...defaultConfig, WelcomeContent: WelcomeBuilder,NotFoundPageComponent,RegistrationComponent  };

export { componentsConfig };